import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export const Other = () => <MoreHorizIcon fontSize="small" />;
